"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var _styles = require("./styles");

var _react = require("react");

var _CustomIcon = require("../../../atoms/CustomIcon");

var _ButtonV = require("../../../atoms/ButtonV2");

var _Image = require("../../../atoms/Image");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _jsxRuntime = require("react/jsx-runtime");

var Header = function Header(props) {
  var showBtnClose = props.showBtnClose,
      showChatsList = props.showChatsList,
      chatCompany = props.chatCompany,
      multipleCompanies = props.multipleCompanies,
      onClickBtnChooseChat = props.onClickBtnChooseChat,
      onClickBtnClose = props.onClickBtnClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      children: [showChatsList ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomIcon.CustomIcon, {
          className: "icon-chooseChat",
          type: "pink",
          borderType: "circle",
          size: 10,
          icon: _freeSolidSvgIcons.faComments
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: "title",
          children: " Todos los chats "
        })]
      }) : chatCompany && chatCompany.id && chatCompany.name && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
          className: "logoCompany",
          width: "24px",
          sizeLoading: 20,
          colorLoading: undefined,
          src: chatCompany.src,
          componentDefault: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomIcon.CustomIcon, {
            className: "icon-logoCompany",
            type: "white",
            borderType: "circle",
            size: 12,
            icon: _freeSolidSvgIcons.faImage
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          className: "title",
          children: [" ", chatCompany.name, " "]
        }), multipleCompanies && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
          className: "btn-chooseChat",
          type: "pink",
          size: 10,
          borderType: "circle",
          icon: _freeSolidSvgIcons.faComments,
          onClick: function onClick(event) {
            return onClickBtnChooseChat && onClickBtnChooseChat();
          }
        })]
      }), showBtnClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        className: "btn-X",
        type: "white",
        size: 11,
        borderType: "circle",
        icon: _freeSolidSvgIcons.faClose,
        onClick: function onClick(event) {
          return onClickBtnClose && onClickBtnClose();
        }
      })]
    })
  });
};

exports.Header = Header;